<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Envios del Evento Masivo </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:[`item.opciones`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-1" color="green" v-bind="attrs" v-on="on" @click="preguntar(item)">
                mdi-clipboard-check-multiple
              </v-icon>
            </template>
            <span> Verificar </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      headers: [
        { text: 'Cantidad Factura', value: 'cantidadFactura' },
        { text: 'Codigo Recepcion', value: 'codigoRecepcion' },
        { text: 'Codigo descripcion', value: 'codigodescripcion' },
        { text: 'nit', value: 'nit' },
        { text: 'fecha', value: 'fecha' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: 140 },
      ],
      desserts: [],
    }),

    components: {},

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        let vue = this;
        vue.loading = true;
        let ideventomasivo = this.$route.query.ideventomasivo;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventomasivo/${ideventomasivo}/enviomasivo`,
          headers: {
            apikey: this.$store.getters.getApiKey,
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data.reverse();
            window.console.log('envios:', data);
            vue.desserts = data;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      newregevento(item) {
        let e = this.desserts.find((x) => x.id == item.id);
        if (e) {
          e.codigo = item.codigo;
          e.codigoPuntoVenta = item.codigoPuntoVenta;
          e.numero_documento = item.numero_documento;
          e.codigoSucursal = item.codigoSucursal;
          e.descripcion = item.descripcion;
        } else {
          this.initialize();
        }
      },
      preguntar(item) {
        let vue = this;
        let opt = {
          verification: 'si',
          verificationHelp: 'Escriba "[+:verification]" para Sincronizar Hora.',
          okText: 'Verificar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        var message = {
          title: 'Confirmar la verificacion del paquete',
          body: '',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.finalizarItem(item, dialog);
          })
          .catch(function() {});
      },
      finalizarItem(item, dialog) {
        let vue = this;
        let data = {
          envioMasivoID: item.id,
          tipoDocumentoSector: 11,
        };
        var config = {
          method: 'post',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/emision/masivo/verificar/documentosector`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.$store.getters.getApiKey,
          },
          data: data,
        };

        xaxios.request(config)
          .then(function(response) {
            window.console.log(response);
            dialog.close();
            vue.$root.$notify.show('Ok', { color: 'success' });
            vue.initialize();
          })
          .catch(function(error) {
            window.console.log(error);
            dialog.close();
            vue.$root.$notify.show('Error', { color: 'red' });
          });
      },
    },
  };
</script>
